<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 700px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="22" v-html="'&nbsp;'" />
          <el-col :span="2">
            <el-button type="success" size="medium" @click="openDialog('select')"
              v-if="checkButtonPermission('front:manage:brand:check')">勾选品牌</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" max-height="700">
          <el-table-column prop="image" label="品牌Logo" width="320">
            <template slot-scope="scope">
              <img :src="scope.row.carBrandImage" width="80" height="80" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="deleteHomeBrand(scope.row.carBrandId)" type="danger" size="mini"
                v-if="checkButtonPermission('front:manage:brand:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog title="勾选渠道" :visible.sync="homeBrandDialogVisible" :modal="false" :close-on-click-modal="false"
      @close="resetForm('homeBrandForm')">
      <el-form :model="homeBrandForm" ref="homeBrandForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="首页品牌" prop="name">
          <el-select v-model="homeBrandSelect" multiple collapse-tags placeholder="请勾选">
            <el-option-group v-for="group in brandGroups" :key="group.label" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="homeBrandDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitHomeBrand('homeBrandForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "homeBrand",
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 1,
      total: 10,
      key: '',
      homeBrandForm: {},
      homeBrandDialogVisible: false,
      brandGroups: [
        {
          label: 'B',
          options: [
            {
              label: '宝马',
              value: 'abc'
            },
            {
              label: '奔驰',
              value: 'abd'
            },
          ]
        }
      ],
      homeBrandSelect: [],
    }
  },
  created() {
    this.getHomeBrands();
  },
  methods: {
    deleteHomeBrand(brandId) {

      this.$http.post('/api/front/home/brand/delete?brandId=' + brandId, {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let status = resp.status;
        console.log(resp)
        if (status == 200) {
          let data = resp.data.data;
          let code = resp.data.code;
          if (reqCode.SUCCESS == code) {
            this.$message({
              message: '删除首页品牌成功',
              type: 'success'
            });
            this.homeBrandDialogVisible = false;
            this.getHomeBrands();
          }
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    submitHomeBrand(fromName) {
      console.log(this.homeBrandSelect);
      this.$http.post('/api/front/home/brand/adds', { brandIds: this.homeBrandSelect }, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let status = resp.status;
        console.log(resp)
        if (status == 200) {
          let data = resp.data.data;
          let code = resp.data.code;
          if (reqCode.SUCCESS == code) {
            this.$message({
              message: '添加首页品牌成功',
              type: 'success'
            });
            this.homeBrandDialogVisible = false;
            this.getHomeBrands();
          }
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getHomeBrands() {
      this.$http.post('/api/front/home/brand/brands', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        let code = data.code;
        if (null != code && undefined != code && reqCode.SUCCESS == code) {
          this.tableData = data.data;
        }
      }).catch(e => {

      })
    },
    openDialog(dialogAction) {
      this.homeBrandDialogVisible = true;
      this.getBrandGroups();
    },
    getBrandGroups() {
      /// /api/car-service/brand/label

      this.$http.post('/api/car/brand/label', null).then(resp => {
        let status = resp.status;
        if (status == 200) {
          let data = resp.data.data;
          let code = resp.data.code;
          if (reqCode.SUCCESS == code) {
            console.log(data);
            let keys = Object.keys(data);
            let groups = [];
            keys.forEach(key => {
              let group = {};
              group.label = key;
              let datum = data[key];
              let opt = [];
              datum.forEach(item => {
                let option = {};
                let value = item.carBrandId;
                let label = item.carBrandName;
                option.label = label;
                option.value = value;
                opt.push(option);
                group.options = opt;
              });
              groups.push(group);
            });
            console.log(groups);
            this.brandGroups = groups;
          }
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    currentPageChange(val) {
      this.currentPage = val;
    },
    pageSizeChange(val) {
      this.pageSize = val;
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.homeBrandForm = {};
        this.homeBrandSelect = [];
        this.$refs[formName].resetFields();
      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/homeBrand.vue